import { Component, OnInit, Input } from '@angular/core';
import { MatIconRegistry } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-log-file-download',
  templateUrl: './log-file-download.component.html',
  styleUrls: ['./log-file-download.component.scss']
})
export class LogFileDownloadComponent implements OnInit {

  @Input() url;
  @Input() type;

  constructor(
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer
  ) { 
    iconRegistry.addSvgIcon(
      'txt-file',
      sanitizer.bypassSecurityTrustResourceUrl('../../../assets/images/icons/txt-file.svg'));
  }

  ngOnInit() {

  }

  downloadFile() {
    var link = document.createElement("a");
    link.setAttribute('download', "");
    link.setAttribute('target', "blank");
    link.href = this.url;
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

}
